import { create } from 'zustand';

import type { ServerEvent } from '@tasks/contracts';

/**
 * Отложенные realtime-события (docs/06 §5.10): пока пользователь тащит
 * карточку, чужие изменения не должны «выдёргивать» её из-под курсора.
 * События копятся и применяются после завершения drag.
 */

export type FloatingState = {
  readonly isDraggingCard: boolean;
  readonly deferredEvents: readonly ServerEvent[];
  beginDrag: () => void;
  endDrag: () => void;
  deferEvent: (event: ServerEvent) => void;
  takeDeferredEvents: () => readonly ServerEvent[];
};

export const useFloatingStore = create<FloatingState>((set, get) => ({
  isDraggingCard: false,
  deferredEvents: [],
  beginDrag: () => set({ isDraggingCard: true }),
  endDrag: () => set({ isDraggingCard: false }),
  deferEvent: (event) => set((state) => ({ deferredEvents: [...state.deferredEvents, event] })),
  takeDeferredEvents: () => {
    const { deferredEvents } = get();
    set({ deferredEvents: [] });
    return deferredEvents;
  },
}));
